import {computed, ref} from 'vue'
import {isDark} from '@/theme/theme.service'
import {colorSchemeDark, colorSchemeLight, themeBalham, themeQuartz} from 'ag-grid-community'

const baseTheme = ref(themeBalham)

export const agTheme = computed(() => {
    return isDark.value ? baseTheme.value.withPart(colorSchemeDark) : baseTheme.value.withPart(colorSchemeLight)
})

const reconciliationBase = themeQuartz.withParams({
    backgroundColor: 'transparent',
    headerBackgroundColor: 'transparent',
    borderColor: 'var(--ui-border)',
    rowHoverColor: 'var(--ui-bg-elevated)',
    foregroundColor: 'var(--ui-text)',
    headerTextColor: 'var(--ui-text-muted)',
    columnBorder: false,
    rowBorder: true,
    fontSize: 14,
    headerFontWeight: 600,
    cellHorizontalPaddingScale: 0.75,
    wrapperBorder: false,
    headerRowBorder: true,
})

export const reconciliationAgTheme = computed(() => {
    return isDark.value
        ? reconciliationBase.withPart(colorSchemeDark)
        : reconciliationBase.withPart(colorSchemeLight)
})
